var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoApprove2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.727,
    height: 78.729,
    viewBox: "0 0 78.727 78.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1435",
    "data-name": "Trac\\xE9 1435",
    d: "M2.593,46.276a39.32,39.32,0,1,1,.8,7.931,39.364,39.364,0,0,1-.8-7.931Z",
    transform: "translate(-2.593 -6.91)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Logo-BG-Approve_2_",
    "data-name": "Logo-BG-Approve (2)",
    transform: "translate(-2.593 -6.91)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_769",
    "data-name": "Groupe 769",
    transform: "translate(2.593 6.91)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 39.364,
    cy: 39.364,
    r: 39.364,
    transform: "translate(0 0.002)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_768",
    "data-name": "Groupe 768",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 85.731,
    height: 55.423,
    transform: "translate(-4.995 -13.311)",
    fill: "#0094cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_767",
    "data-name": "Groupe 767",
    transform: "translate(15.637 9.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1433",
    "data-name": "Trac\\xE9 1433",
    d: "M38.38,12.211a23.793,23.793,0,0,1,11.851,5.5c-1.011.923-1.994,1.882-2.941,2.851a19.8,19.8,0,1,0,6.775,11.363,34.719,34.719,0,0,1,3.671-2.2A23.906,23.906,0,1,1,38.379,12.215",
    transform: "translate(-10.711 -11.914)",
    fill: "#004b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1434",
    "data-name": "Trac\\xE9 1434",
    d: "M16.057,29.592a23.827,23.827,0,0,1,9.524-4.08A30.89,30.89,0,0,1,30,37.016c7.645-9.88,17.19-22.125,26.194-23.934a40.248,40.248,0,0,0-2.626,12.989C43.9,28.906,34.688,39.931,28.331,47.287c-2.246-5.96-6.341-14.771-12.274-17.695",
    transform: "translate(-5.758 -10.831)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "AP",
    transform: "translate(16.572 66.058)",
    fill: "#fff",
    fontSize: 29,
    fontFamily: "Young",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.05em"
  }, "P"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApprove2);
export default __webpack_public_path__ + "static/media/Logo-Approve2.ff202168bfb06d0ce54631728d658ed0.svg";
export { ForwardRef as ReactComponent };